<template>
  <Page>
    <!--    <BSearch-->
    <!--      :search-list="searchList"-->
    <!--      @on-search="searchHandler"-->
    <!--    >-->
    <!--    </BSearch>-->
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      :rowKey="(text, index) => index"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
    </BTable>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'Product',
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        const request = {
          ...this.queryParam
        }
        return this.$http.product.productQueryPage(Object.assign(parameter, { request })).then(response => {
          const { data } = response
          return data
        })
      },
      // searchList: [
      //   {
      //     label: '商户简称',
      //     key: 'interfaceName',
      //     type: 'select',
      //     options: []
      //   },
      //   {
      //     label: '汇率渠道',
      //     key: 'interfaceName',
      //     type: 'select',
      //     options: []
      //   },
      //   {
      //     label: '卖出币种',
      //     key: 'account',
      //     type: 'select'
      //   }, { // 这个是接口没有
      //     label: '买入币种',
      //     key: 'status',
      //     type: 'select'
      //   }
      // ],
      columns: Object.freeze([
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '产品类型',
          dataIndex: 'id' // no
        },
        {
          title: '产品',
          dataIndex: 'proName'
          // sorter: true,
          // needTotal: true,
          // customRender: (text) => text + ' 次'
        },
        {
          title: '状态',
          dataIndex: 'status',
          customRender: (text, record, index) => {
            const { status } = record // Y 启用
            const checked = status === 'Y'
            return (
              <a-switch
                key={record.id}
                checked-children="启用" un-checked-children="禁用"
                loading={this.changeLoading}
                defaultChecked={checked}
                onChange={value => { this.handleChange(record, value) }}></a-switch>
            )
          }
          // needTotal: true
        },
        {
          title: '创建人', // 请求接口？
          dataIndex: 'creator'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
          // customRender: () => '没有'
        }
      ]),
      changeLoading: false
    }
  },
  methods: {
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    },
    async handleChange (record, value) {
      this.changeLoading = true
      const { succ } = await this.$http.product.productEnableDisable({ enable: value, id: record.id })
      this.changeLoading = false
      if (succ) {
        this.$message.destroy()
        this.$message.success('状态修改成功!')
        this.$refs.table.refresh()
      }
    }
  }
}
</script>

<style scoped lang="less">
</style>
